<template>
	<v-card>
		<v-card-title class="d-flex align-center">
			<v-icon
				icon="$gavel"
				start
			/>
			<translate>
				Pending Orders
			</translate>
		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col md="4">
					<v-select
						v-if="resellers"
						v-model="resellerFilter"
						:items="resellers"
						:label="`${$gettext('Reseller')} ${$gettext('filter')}`"
						clearable
						variant="outlined"
					/>
				</v-col>
				<v-col>
					<v-text-field
						v-model="orderSearch"
						append-inner-icon="$search"
						:label="$gettext('Search')"
						single-line
						hide-details
						variant="outlined"
					/>
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col>
					<model-table
						ref="modelTable"
						v-model="items"
						:search="orderSearch"
						:custom-filter="nameFilter"
						endpoint="/bo/pending/index"
						:headers="tableHeaders"
						@items-retrieved="getFilterData($event)"
					>
						<template #item.actions="{ item }">
							<review-dialog
								:orderrow-id="item.orderrowId"
								:order-id="item.orderId"
								:orderkey="item.orderkey"
								:name-first="item.nameFirst"
								:name-last="item.nameLast"
								:birth-day="item.birthDay"
								:infix="item.infix"
								:ccbr-report="item.ccbrReport"
								:status="item.status"
								@input="v => v || updateTable()"
							>
								<template #activator="{ props }">
									<v-btn
										color="primary"
										v-bind="props"
										size="small"
										variant="text"
									>
										<translate>
											Review
										</translate>
									</v-btn>
								</template>
							</review-dialog>
						</template>
						<template #item.orderkey="{ item }">
							<a :href="`/bo/orders/view?id=${item.orderId}`">
								{{ item.orderkey }}
							</a>
						</template>
						<template #item.latestCommunication="{ item }">
							{{ item.latestCommunication || $gettext('None') }}
						</template>
						<template #item.name="{ item }">
							<a :href="`/bo/users/view?id=${item.userId}`">
								{{ item.nameFull }}
							</a>
						</template>
					</model-table>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import ModelTable from '../molecules/ModelTable.vue';
import ReviewDialog from './ReviewDialog.vue';
export default {
	name: 'PendingOrders',
	components: {
		ReviewDialog,
		ModelTable
	},

	data () {
		return {
			items: [],
			orderSearch: '',
			resellers: [],
			resellerFilter: '',
			options: {
			},
		};
	},

	computed: {
		tableHeaders () {
			return [
				{
					title: this.$gettext('Name'), value: 'name', sortable: false,
				},
				{
					title: this.$gettext('Orderkey'), value: 'orderkey', sortable: false,
				},
				{
					title: this.$gettext('Latest Communication'), value: 'latestCommunication', sortable: false,
				},
				{
					title: this.$gettext('Reseller'), value: 'reseller', sortable: false, filterable: true,
				},
				{
					title: null, value: 'actions', align: 'right', sortable: false,
				},
			];
		}
	},

	methods: {

		/**
		 * Update the internal table
		 *
		 * @returns {void}
		 */
		updateTable () {
			this.$refs.modelTable.index();
		},

		/**
		 * Search on name
		 *
		 * @param {object} value value
		 * @param {string} search user inputted search
		 * @param {object} item all order data
		 * @returns {boolean} in filter or out
		 */
		nameFilter (value, search, item) {
			return item.raw.nameFull.toUpperCase().includes(search.toUpperCase());
		},

		/**
		 * Get data from the model table component and set the resellers select to have the unique set
		 *
		 * @param {Array} e Array containing the data fetched from the table
		 */
		getFilterData (e) {
			this.resellers = [...new Set(e.map((item) => item.reseller)), ];
		}
	}
};
</script>
